import { RootState } from '../../store';

export const getPositionsSelector = (state: RootState) => state?.positionReducer?.positions;
